<template>
    <div>
        <div class="row mt-4 d-none" v-if="outOfStock && basketProductId">
            <div class="col mt-2">
                <form method="post" id="stock-notification-request" :action="stockNotificationRoute">
                <p class="mb-2 notify-text">NOTIFY ME WHEN THIS ITEM IS BACK IN STOCK</p>
                <div class="form-group">
                    <div class="input d-flex">
                    <input  type="email" id="stock-notification-email"
                            name="stock-notification-email" class="form-control stock-notification-input"
                            :value="email" ref="stockNotificationEmail"
                    />
                    <input type="hidden" name="_token" :value="csrf">
                    <button @click="submitStockNotificationRequest" id="stock-notification-submit" class="btn btn-secondary" type="button">Submit</button>
                    </div>
                </div>
                <p v-if="stockNotificationSent" :class="'mb-2 alert ' + messageType">{{stockNotificationMessage}}</p>
                </form>
            </div>
        </div>

        <div v-if="loading" class="d-flex align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../app.js";
export default {
    data() {
        return {
            loading: false,
            success: false,
            stockNotificationSent: false,
            stockNotificationMessage: "",
            basketProductId: null,
            stockWarningMessage: null,
            outOfStock: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        };
    },

    props: {
        schoolId: {
            type: Number,
        },
        branchId: {
            type: Number,
        },
        email: {
            type: String,
        },
        stockNotificationRoute: {
            type: String,
        },
        userId: {
            type: String,
        },
    },

    methods: {
        submitStockNotificationRequest() {
            this.loading = true;
            axios.post('/api/v1/product/stock-notification-request',
                {
                    productId: this.basketProductId,
                    branchId: this.$props.branchId,
                    email: this.$refs.stockNotificationEmail.value,
                    productUrl: window.location.href,
                }
            )
            .then(res => {
                if (res.data) {
                    this.stockNotificationSent = true;
                    this.stockNotificationMessage = res.data.message;

                    if(res.data.success == true) {
                        this.messageType = 'alert-success';
                    } else {
                        this.messageType = 'alert-danger';
                    }

                }
            })
            .catch(error => {
                this.messageType = 'alert-danger';
                this.stockNotificationMessage = "";
                for (const msg in error.response.data.errors) {
                    this.stockNotificationMessage = this.stockNotificationMessage.concat(" ", error.response.data.errors[msg][0]);
                }

                this.stockNotificationSent = true;
            })
            .finally(res => {
                this.loading = false;
            });
        },
    },

    created () {
        EventBus.$on('dropdown-change', (data) => {
            this.basketProductId = data.product_id
            this.outOfStock = data.out_of_stock
        })
    }
}

</script>


<style scoped>
    .btn-primary {
        border-radius: 0 3px 3px 0;
    }

    .stock-notification-input {
        border-radius: 3px 0 0 3px;
    }
</style>
